import { useState } from 'react';
import { Grid, Paper } from '@mui/material';
import { Table } from '@components/Table/Table';
import { ResponsesFilter, ResponsesFilterFormValues } from './ResponsesFilter';
import { getColumns } from './columns';
import { useGetResponses } from './hooks/useGetResponses';
import styles from './styles.module.scss';

export const ResponsesTable = () => {
  const [filterValues, setFilterValues] = useState<ResponsesFilterFormValues>({});
  const { data: responses, isLoading } = useGetResponses(filterValues);

  const columns = getColumns();

  const onChange = (values: ResponsesFilterFormValues) => {
    setFilterValues(values);
  };

  return (
    <>
      <Grid>
        <ResponsesFilter onChange={onChange} />
      </Grid>
      <Grid item sx={{ width: '100%' }}>
        <Paper className={styles.paper}>
          <Table columns={columns} data={responses} loading={isLoading} />
        </Paper>
      </Grid>
    </>
  );
};
